<template>
  <div class="gallery mx-auto w-full" v-if="coverList">
    <div class="relative">
      <swiper :options="swiperOptionTop" class="swiper-top swiper gallery-top" ref="swiperTop">
        <swiper-slide v-for="(item, index) in coverList" :key="index">
          <div class="item cursor-pointer w-full h-full" @click.prevent.stop="openPreview(index)">
            <div class="square-book mx-auto w-full" style="padding-bottom: 100% !important">
              <div class="square-img book-shadow" v-lazy:background-image="{ src: item.url }" style="padding-bottom: 100% !important"></div>
              <div class="playerIcon-preview absolute z-50 w-full text-center" v-if="coverList[index].youtube_url">
                <ul>
                  <li class="inline">
                    <a class="openvideoBtn cursor-pointer block relative mx-auto" id="openvideoBtn">
                      <img src="~@/assets/btn/video_icon.png" class="object-contain border-0 w-full h-full">
                    </a>
                  </li>
                </ul>
              </div>
              <!-- 數位軟體壓LOGO -->
              <div class="digi-mask mx-auto border-0 absolute z-50" v-if="is_digital && ['154', '160', '161', '162', '163', '155'].indexOf(category_id.toString()) > -1">
                <img src="~@/assets/icon/mask.png" class="w-full h-full object-contain mx-auto">
              </div>
            </div>
          </div>
        </swiper-slide>
        <!-- <div class="swiper-pagination md:hidden" slot="pagination" v-if="coverList.length > 1"></div> -->
      </swiper>
      <div class="swiper-pagination md:hidden text-sm my-1" slot="pagination" v-if="coverList.length > 1"></div>
      <!-- <div class="swiper-button-black swiper-button-next swiper-button-next-top focus:outline-none cursor-pointer absolute md:hidden" v-if="coverList.length > 1"></div>
      <div class="swiper-button-black swiper-button-prev swiper-button-prev-top focus:outline-none cursor-pointer absolute md:hidden" v-if="coverList.length > 1"></div> -->
    </div>

    <div class="relative md:px-6 md:mt-6">
      <div class="swiper-thumbs swiper-container" id="swiperThumb">
        <div class="swiper-wrapper">
          <div :key="'thumb' + index" class="swiper-slide" v-for="(item, index) in coverList" >
            <div class="item cursor-pointer w-full h-full">
              <div class="square-book md:border-2 md:border-solid mx-auto">
                <div class="square-img book-shadow" v-lazy:background-image="{ src: item.url }"></div>
                <div class="playerIcon-preview absolute z-50 w-full text-center" v-if="coverList[index].youtube_url">
                  <ul>
                    <li class="inline">
                      <a class="openvideoBtn cursor-pointer inline-block relative w-8 h-8" id="openvideoBtn">
                        <img src="~@/assets/btn/video_icon.png" class="object-contain border-0">
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-black swiper-button-next swiper-button-next-preview focus:outline-none cursor-pointer absolute hidden md:block" v-if="coverList.length > 4"></div>
      <div class="swiper-button-black swiper-button-prev swiper-button-prev-preview focus:outline-none cursor-pointer absolute hidden md:block" v-if="coverList.length > 4"></div>
    </div>
    <CoolLightBox
      :items="previewList"
      :index="index"
      :fullScreen="true"
      @close="index = null">
    </CoolLightBox>
  </div>
</template>
<script>
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
export default {
  name: 'Gallery',
  data () {
    return {
      index: null,
      swiperOptionTop: {
        navigation: {
          nextEl: '.swiper-button-next-top',
          prevEl: '.swiper-button-prev-top'
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        thumbs: {
          swiper: {
            el: '#swiperThumb',
            slidesPerView: 4,
            watchSlidesVisibility: true,
            spaceBetween: 10,
            navigation: {
              nextEl: '.swiper-button-next-preview',
              prevEl: '.swiper-button-prev-preview'
            }
          }
        }
      }
    }
  },
  props: {
    coverList: {
      type: Array,
      required: true
    },
    is_digital: {
      type: Boolean,
      default: false
    },
    isFavorite: {
      type: Boolean,
      default: false
    },
    category_id: {
      type: Number
    }
  },
  components: {
    CoolLightBox
  },
  computed: {
    previewList () {
      let self = this
      if (self.coverList.length > 0) {
        let list = []
        for (let item of self.coverList) {
          if (item.youtube_url) {
            list.push(item.youtube_url)
          } else {
            list.push(item.url)
          }
        }
        return list
      } else {
        return []
      }
    }
  },
  mounted () {
  },
  methods: {
    openPreview (index) {
      let self = this
      if (self.coverList.length > 0) {
        self.index = index
      }
    }
  }
}
</script>
<style lang="scss">
  .gallery {
    .SlideImage {
      top: 0;
      left: 0;
      background:rgba(0,0,0,0.65);
      z-index: 20;
      .main {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        .card {
          img {
            max-height: 75vh;
          }
          .closeBtn {
            width: 40px;
            height: 40px;
            opacity: 0.65;
            right: -40px;
            top:  -40px;
          }
          .preImage {
            background-color: white;
            border-color: #959595;
          }
        }
      }

    }
    .swiper-container {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }
    .swiper-button-next-top, .swiper-button-prev-top {
      z-index: 99;
      background-size: 27px 44px !important;
      width: 10vw !important;
      height: 100%;
      transform: translateY(-50%);
      background-position: center;
    }
    .swiper-button-next-top {
      right: -2% !important;
    }
    .swiper-button-prev-top {
      left: -2% !important;
    }
    .swiper-button-next-preview {
      z-index: 10;
      right: -2% !important;
      transform: translateY(-50%);
      margin-top: 0 !important;
      background-size: 25px 25px !important;
      background-position: center;
      width: 35px !important;
      height: 100%;
      background-image: url('~@/assets/btn/arrowRight.png') !important;
      @media (min-width: 768px) {
      }
      @media (min-width: 1440px) {
        background-size: 28px 28px !important;
        width: 40px !important;
        right: -3% !important;
      }
    }
    .swiper-button-prev-preview {
      z-index: 10;
      left: -2% !important;
      transform: translateY(-50%);
      margin-top: 0 !important;
      background-size: 25px 25px !important;
      background-position: center;
      width: 35px !important;
      height: 100%;
      background-image: url('~@/assets/btn/arrowLeft.png') !important;
      @media (min-width: 768px) {
      }
      @media (min-width: 1440px) {
        background-size: 28px 28px !important;
        width: 40px !important;
        left: -3% !important;
      }
    }
    .swiper-pagination {
      position: relative !important;
      bottom: 0px;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
      background: #e60012 !important;
    }
    .square-book {
      position: relative;
      width: 90%;
      padding-bottom : 90%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      .square-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding-bottom : 90%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .playerIcon-preview {
        top: 50%;
        transform: translateY(-50%);
        ul {
          li {
            a {
              width: 90px;
              height: 90px;
            }
          }
        }
      }
    }
  }

</style>
